import React, { useCallback, useEffect, useState } from "react";
import "./test.css";
import { useParams } from "react-router-dom";
import { findPostableSlip, getBetslip } from "./utils/betslip";
import {
  setState as setMatchBetslipOptions,
  setPickedData,
} from "../redux/bettingSlice";
import { MarketList } from "./matches";

import {
  favoriteMarkets,
  matchesMoreLiveMarkets,
  matchesMorePrematchMarkets,
  setFetching,
  setInitialLoadingState,
  startFetchingMoreMatches,
  stopFetchingMoreMatches,
} from "../redux/matchesSlice";
import { useDispatch, useSelector } from "react-redux";
import {
  setMatchBetslip,
  setSelected,
  stopBetslipValidation,
} from "../redux/bettingSlice";
import { getFromLocalStorage } from "./utils/local-storage";
import SkeletonLoaderMore from "./pages/skeletonLoadersWeb/SkeletonLoaderMore";
import { setState } from "../redux/dataSlice";

const AllMarkets = React.memo((props) => {
  const [allMarkets] = useState(true);
  const params = useParams();
  const dispatchRedux = useDispatch();
  const { live } = props;

  const id = params.id;
  // const [userSlipsValidation, setUserSlipsValidation] = useState();
  const mkGroup = useSelector((state) => state.matchesData.market_groups);
  const fetching = useSelector((state) => state.matchesData.live_fetching);
  const moreMatches = useSelector((state) => state.matchesData.more_matches);
  const producer_down = useSelector((state) => state.matchesData.producer_down);
  const [market_groups, setMarketGroups] = useState(
    getFromLocalStorage("market_groups")
  );
  const [matches, setMatches] = useState();

  useEffect(() => {
    const cache = getFromLocalStorage("market_groups");
    setMarketGroups(mkGroup || cache);
  }, [mkGroup]);

  useEffect(() => {
    setMatches(moreMatches);
  }, [moreMatches]);

  const clean = (str) => {
    return str.replace(/\s+/g, "");
  };

  const setInitialData = () => {
    const betslip = getBetslip();
    const betslip_data = {
      betslip_type: "betslip",
      data: betslip,
    };
    Object.entries(betslip || {}).map(([matchId, match]) => {
      let uc = clean(
        match.parent_match_id?.toString() +
          match.sub_type_id?.toString() +
          match?.outcome_id?.toString() +
          match?.special_bet_value?.toString()
      );
      const reference = match.parent_match_id + "_selected";

      dispatchRedux(setSelected(reference, uc));
      if (id.toString() === match?.parent_match_id?.toString()) {
        dispatchRedux(setPickedData(uc.toString()));
      }
    });

    dispatchRedux(setMatchBetslip(betslip_data));
  };
  const pathname = window.location.pathname;

  const fetchPagedData = async () => {
    if (!isNaN(id)) {
      let betslip = findPostableSlip();
      let endpoint = pathname.includes("live")
        ? "/v3/matches/live?id=" + id
        : "/v3/matches?id=" + id;
      if (live) {
        dispatchRedux(
          matchesMoreLiveMarkets({ endpoint, method: "POST", data: betslip })
        );
        dispatchRedux(
          startFetchingMoreMatches({
            endpoint,
            method: "POST",
            data: betslip,
            interval: 6000,
            more_live: true,
          })
        );
      } else {
        dispatchRedux(
          matchesMorePrematchMarkets({
            endpoint,
            method: "POST",
            data: betslip,
          })
        );
        dispatchRedux(
          startFetchingMoreMatches({
            endpoint,
            method: "POST",
            data: betslip,
            interval: 20000,
            more_prematch: true,
          })
        );
      }
      setInitialData();
    }
  };

  useEffect(() => {
    const abort = new AbortController();

    return () => {
      abort.abort();
      dispatchRedux(stopBetslipValidation());
      window.SIR("removeWidget", "#sr-widget-1");

      // window.SIR("removeWidget", "#sr-widget-bets");
      // dispatchRedux(setState("show_similar_widget", false));
      dispatchRedux(setMatchBetslipOptions("betslip_validation_status", false));
    };
  }, [id]);

  useEffect(() => {
    const abortController = new AbortController();
    dispatchRedux(stopFetchingMoreMatches());
    const data = {
      param_fetch_type: "more_markets",
      match: id,
    };
    dispatchRedux(setInitialLoadingState(data));
    dispatchRedux(setFetching("fetching", true));
    fetchPagedData();
    return () => {
      dispatchRedux(stopFetchingMoreMatches());
      abortController.abort();
    };
  }, [id]);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, [id]);

  return (
    <>
      {!fetching && matches ? (
        <MarketList
          allMarkets={allMarkets}
          live={pathname.includes("live")}
          matchwithmarkets={matches}
          pdown={producer_down}
          groups={market_groups}
          id={id}
        />
      ) : (
        <div>
          <SkeletonLoaderMore />
        </div>
      )}
    </>
  );
});

export default React.memo(AllMarkets);
